/*
创建者 魏强(2018.2.1)
精品速递
*/
<template>
<div class="home-module mb">
	<h3 class="module-title"><span>精品速递</span></h3>
	<div class="focus-warp">
	    <div class="swipe-wrap" id="qua-swiper">
	        <div class="swipe" id="qua-swiper-container">
	        <Carousel
		      v-model="value"
		      :autoplay="setting.autoplay"
		      :autoplay-speed="setting.autoplaySpeed"
		      :dots="setting.dots"
		      :radius-dot="setting.radiusDot"
		      :trigger="setting.trigger"
		      :arrow="setting.arrow"
		      >
				<CarouselItem v-for="item in nums " :key="item.key">
			        <div class="qua-goods-1" v-if="(item.key*2+0)<jpsdGoodsAdvLeftList.length">
				        <router-link  :to="jpsdGoodsAdvLeftList[item.key*2+0].to" target="_blank"  class="qua-goods-sm">
				          <img  :src="jpsdGoodsAdvLeftList[item.key*2+0].atturl"  width="175" height="500"  />    
				        </router-link>
    			 	</div>
    			 	<div class="qua-goods-2" v-if="(item.key*2+1)<jpsdGoodsAdvLeftList.length">
				        <router-link  :to="jpsdGoodsAdvLeftList[item.key*2+1].to" target="_blank" class="qua-goods-sm">
				          <img  :src="jpsdGoodsAdvLeftList[item.key*2+1].atturl"  width="350" height="500"  />    
				        </router-link>
    			 	</div>
    			 	<div class="qua-goods-3 clearfix">
    			 		<router-link  v-if="(item.key*6+0)<jpsdGoodsAdvRightList.length" 
    			 			:to="jpsdGoodsAdvRightList[item.key*6+0].to" target="_blank" class="qua-goods-sm">
				          <img  :src="jpsdGoodsAdvRightList[item.key*6+0].atturl" class="w170-250"   />    
				        </router-link>
				        <router-link  v-if="(item.key*6+1)<jpsdGoodsAdvRightList.length" 
    			 			:to="jpsdGoodsAdvRightList[item.key*6+1].to" target="_blank" class="qua-goods-sm">
				          <img  :src="jpsdGoodsAdvRightList[item.key*6+1].atturl" class="w170-250"   />    
				        </router-link>
				        <router-link  v-if="(item.key*6+2)<jpsdGoodsAdvRightList.length" 
    			 			:to="jpsdGoodsAdvRightList[item.key*6+2].to" target="_blank" class="qua-goods-sm">
				          <img  :src="jpsdGoodsAdvRightList[item.key*6+2].atturl" class="w170-250"   />    
				        </router-link>
				        <router-link  v-if="(item.key*6+3)<jpsdGoodsAdvRightList.length" 
    			 			:to="jpsdGoodsAdvRightList[item.key*6+3].to" target="_blank" class="qua-goods-sm">
				          <img  :src="jpsdGoodsAdvRightList[item.key*6+3].atturl" class="w170-250"   />    
				        </router-link>
				        <router-link  v-if="(item.key*6+4)<jpsdGoodsAdvRightList.length" 
    			 			:to="jpsdGoodsAdvRightList[item.key*6+4].to" target="_blank" class="qua-goods-sm">
				          <img  :src="jpsdGoodsAdvRightList[item.key*6+4].atturl" class="w170-250"   />    
				        </router-link>
				        <router-link  v-if="(item.key*6+5)<jpsdGoodsAdvRightList.length" 
    			 			:to="jpsdGoodsAdvRightList[item.key*6+5].to" target="_blank" class="qua-goods-sm">
				          <img  :src="jpsdGoodsAdvRightList[item.key*6+5].atturl" class="w170-250"   />    
				        </router-link>
           	 		</div>
			    </CarouselItem>
			 </Carousel>
	        </div>
	    </div>
	</div>
</div>
</template>
<script>
export default{
	props:["jpsdGoodsAdvLeftList","jpsdGoodsAdvRightList","height"],
	computed:{
		nums(){
			let _nums=[];
			let len = this.jpsdGoodsAdvLeftList.length;
			len = Math.ceil( len/2 );
			for(let i=0 ; i<len;i++){
				_nums.push({key:i});
			}
			return _nums;
		}
	},
	data(){
		return {
			value: 0,
              setting: {
                  autoplay: true,
                  autoplaySpeed: 2000,
                  dots: 'none',
                  radiusDot: false,
                  trigger: 'hover',
                  arrow: 'hover'
              }
		}
	}
}
</script>
<style scoped>
	.qua-goods-sm img.w170-250{
		width: 170px;
		height: 250px;
	}
</style>


// WEBPACK FOOTER //
// boutique-express.vue?381f9d3d